module.exports = __webpack_public_path__ + "img/crosshair.637aeaaa.svg";